import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Grid, Card } from '@material-ui/core'
import { Row, Col, Typography, Select, Spin, Input, Button } from 'antd'
import MainContainer from '../../../components/MainContainer'

import './generalSetting.css'

const { Text } = Typography
const { Option } = Select

@inject(
    'loginStore',
    'generalSettingStore'
)
@observer
class GeneralSettingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });

        this.props.generalSettingStore.initGeneralSetting()
        this.props.generalSettingStore.initGeneralSettingModel()
    }

    // ON CHANGE

    companyIdOnChange = (e) => {
        this.props.generalSettingStore.companyIdOnChange(e.target.value)
    }

    stayMenuOnChange = (e) => {
        this.props.generalSettingStore.stayMenuOnChange(e.target.value)
    }

    currencyOnChange = (value) => {
        this.props.generalSettingStore.currencyOnChange(value)
    }

    vatOnChange = (e) => {
        this.props.generalSettingStore.vatOnChange(e.target.value)
    }

    serviceFeeOnChange = (e) => {
        this.props.generalSettingStore.serviceFeeOnChange(e.target.value)
    }

    countryWeatherOnChange = (e) => {
        this.props.generalSettingStore.countryWeatherOnChange(e.target.value)
    }

    timezoneOnChange = (value) => {
        this.props.generalSettingStore.timezoneOnChange(value)
    }

    amenityTaskIdOnChange = (value) => {
        this.props.generalSettingStore.amenityTaskIdOnChange(value)
    }

    bookTaxiTaskIdOnChange = (value) => {
        this.props.generalSettingStore.bookTaxiTaskIdOnChange(value)
    }

    cleanRoomTaskIdOnChange = (value) => {
        this.props.generalSettingStore.cleanRoomTaskIdOnChange(value)
    }

    conciergeItemChanged = (value) => {
        this.props.generalSettingStore.conciergeItemChanged(value)
    }

    defectReportTaskIdOnChange = (value) => {
        this.props.generalSettingStore.defectReportTaskIdOnChange(value)
    }

    dndTaskIdOnChange = (value) => {
        this.props.generalSettingStore.dndTaskIdOnChange(value)
    }

    fnbTaskIdOnChange = (value) => {
        this.props.generalSettingStore.fnbTaskIdOnChange(value)
    }

    frontOfficeTaskIdOnChange = (value) => {
        this.props.generalSettingStore.frontOfficeTaskIdOnChange(value)
    }

    lateCheckoutTaskIdOnChange = (value) => {
        this.props.generalSettingStore.lateCheckoutTaskIdOnChange(value)
    }

    laundryTaskIdOnChange = (value) => {
        this.props.generalSettingStore.laundryTaskIdOnChange(value)
    }

    printFileTaskIdOnChange = (value) => {
        this.props.generalSettingStore.printFileTaskIdOnChange(value)
    }

    shoppingTaskIdOnChange = (value) => {
        this.props.generalSettingStore.shoppingTaskIdOnChange(value)
    }

    wakeUpCallTaskIdOnChange = (value) => {
        this.props.generalSettingStore.wakeUpCallTaskIdOnChange(value)
    }

    // CLICKED Action

    saveGeneralSettingClicked = () => {
        this.props.generalSettingStore.saveGeneralSettingClicked()
    }

    render() {
        const {
            configuration, currencies, timezones, stayMenuCategories, generalSettingLoading, configurationModel
        } = this.props.generalSettingStore;

        let amenityTitle = 'Amenity';
        let bookTaxiTitle = 'Book Taxi';
        let cleanRoomTitle = 'Clean Room';
        let conciergeTitle = 'Concierge';
        let defectReportTitle = 'Defect Report';
        // let dndTitle = 'DND';
        let fnbTitle = 'In Room Dining';
        // let frontOfficeTitle = 'Front Office';
        // let laundryTitle = 'Laundry';
        // let lateCheckoutTitle = 'Late Check Out';
        // let printFileTitle = 'Print File';
        let shoppingTitle = 'Shopping';
        let wakeupCallTitle = 'Wake Up Call';

        if (configurationModel) {
            if (configurationModel.amenity) {
                amenityTitle = configurationModel.amenity.taskName;
            }

            if (configurationModel.bookTaxi) {
                bookTaxiTitle = configurationModel.bookTaxi.taskName;
            }

            if (configurationModel.cleanRoom) {
                cleanRoomTitle = configurationModel.cleanRoom.taskName;
            }

            if (configurationModel.concierge) {
                conciergeTitle = configurationModel.concierge.taskName;
            }

            if (configurationModel.defectReport) {
                defectReportTitle = configurationModel.defectReport.taskName;
            }

            // if (configurationModel.dnd) {
            //     dndTitle = configurationModel.dnd.taskName;
            // }

            if (configurationModel.fnb) {
                fnbTitle = configurationModel.fnb.taskName;
            }

            // if (configurationModel.frontOffice) {
            //     frontOfficeTitle = configurationModel.frontOffice.taskName;
            // }

            // if (configurationModel.lateCheckout) {
            //     lateCheckoutTitle = configurationModel.lateCheckout.taskName;
            // }

            // if (configurationModel.laundry) {
            //     laundryTitle = configurationModel.laundry.taskName;
            // }

            // if (configurationModel.printFile) {
            //     printFileTitle = configurationModel.printFile.taskName;
            // }

            if (configurationModel.shopping) {
                shoppingTitle = configurationModel.shopping.taskName;
            }

            if (configurationModel.wakeUpCall) {
                wakeupCallTitle = configurationModel.wakeUpCall.taskName;
            }
        }

        return (
            <MainContainer title='General Settings'>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: "auto" }}>
                            <Spin spinning={generalSettingLoading}>
                                <Row className='generalSetting-row-category-first'>
                                    <Col span={24}>
                                        <Text className='generalSetting-text-category'>General</Text>
                                    </Col>
                                </Row>

                                {/* <Row className='generalSetting-row-subcategory'>
                                    <Col span={4}>
                                        <Text className='generalSetting-text-subcategory'>Company ID</Text>
                                    </Col>
                                    <Col span={4}>
                                        <Input value={configuration === null ? 0 : configuration.companyId} onChange={this.companyIdOnChange} />
                                    </Col>
                                </Row> */}

                                {/* <Row className='generalSetting-row-subcategory'>
                                    <Col span={4}>
                                        <Text className='generalSetting-text-subcategory'>Stay Menu Item</Text>
                                    </Col>
                                    <Col span={4}>
                                        <Input value={configuration === null ? 0 : configuration.stayMenuTaskId} onChange={this.stayMenuOnChange} />
                                    </Col>
                                </Row> */}

                                <Row className='generalSetting-row-subcategory'>
                                    <Col span={4}>
                                        <Text className='generalSetting-text-subcategory'>VAT (%)</Text>
                                    </Col>
                                    <Col span={4}>
                                        <Input value={configuration === null ? 0 : configuration.vat} onChange={this.vatOnChange} />
                                    </Col>
                                </Row>

                                <Row className='generalSetting-row-subcategory'>
                                    <Col span={4}>
                                        <Text className='generalSetting-text-subcategory'>Service Fee (%)</Text>
                                    </Col>
                                    <Col span={4}>
                                        <Input value={configuration === null ? 0 : configuration.serviceFee} onChange={this.serviceFeeOnChange} />
                                    </Col>
                                </Row>

                                <Row className='generalSetting-row-subcategory' />

                                <Row className='generalSetting-row-subcategory'>
                                    <Col span={4}>
                                        <Text className='generalSetting-text-subcategory'>Country's Weather</Text>
                                    </Col>
                                    <Col span={4}>
                                        <Input value={configuration === null ? 0 : configuration.countryWeather} onChange={this.countryWeatherOnChange} />
                                    </Col>
                                </Row>

                                <Row className='generalSetting-row-subcategory'>
                                    <Col span={4}>
                                        <Text className='generalSetting-text-subcategory'>Timezone</Text>
                                    </Col>
                                    <Col span={8}>
                                        <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.timezone} style={{ width: 120 }} onChange={this.timezoneOnChange}>
                                            {configuration !== null ? (
                                                timezones.map(timezone => {
                                                    return (
                                                        <Option value={timezone.timezoneCode}>{timezone.timezoneName}</Option>
                                                    )
                                                })
                                            ) : null}
                                        </Select>
                                    </Col>
                                </Row>

                                <Row className='generalSetting-row-subcategory'>
                                    <Col span={4}>
                                        <Text className='generalSetting-text-subcategory'>Currency</Text>
                                    </Col>
                                    <Col span={8}>
                                        <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.currency} style={{ width: 120 }} onChange={this.currencyOnChange}>
                                            {configuration !== null ? (
                                                currencies.map(currency => {
                                                    return (
                                                        <Option value={currency.currencyName}>{currency.currencyName}</Option>
                                                    )
                                                })
                                            ) : null}
                                        </Select>
                                    </Col>
                                </Row>

                                <Row className='generalSetting-row-subcategory' />

                                {
                                    amenityTitle === '' ?
                                        null
                                        :
                                        <Row className='generalSetting-row-subcategory'>
                                            <Col span={4}>
                                                <Text className='generalSetting-text-subcategory'>{amenityTitle}</Text>
                                            </Col>
                                            <Col span={8}>
                                                <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.amenitiesTaskId} style={{ width: 120 }} onChange={this.amenityTaskIdOnChange}>
                                                    <Option value={0}>-- Select --</Option>
                                                    {configuration !== null ? (
                                                        stayMenuCategories.map(item => {
                                                            return (
                                                                <Option value={item.parentId}>{item.parentName}</Option>
                                                            )
                                                        })
                                                    ) : null}
                                                </Select>
                                            </Col>
                                        </Row>
                                }

                                {
                                    bookTaxiTitle === '' ?
                                        null
                                        :
                                        <Row className='generalSetting-row-subcategory'>
                                            <Col span={4}>
                                                <Text className='generalSetting-text-subcategory'>{bookTaxiTitle}</Text>
                                            </Col>
                                            <Col span={8}>
                                                <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.bookTaxiTaskId} style={{ width: 120 }} onChange={this.bookTaxiTaskIdOnChange}>
                                                    <Option value={0}>-- Select --</Option>
                                                    {configuration !== null ? (
                                                        stayMenuCategories.map(item => {
                                                            return (
                                                                <Option value={item.parentId}>{item.parentName}</Option>
                                                            )
                                                        })
                                                    ) : null}
                                                </Select>
                                            </Col>
                                        </Row>
                                }

                                {
                                    cleanRoomTitle === '' ?
                                        null
                                        :
                                        <Row className='generalSetting-row-subcategory'>
                                            <Col span={4}>
                                                <Text className='generalSetting-text-subcategory'>{cleanRoomTitle}</Text>
                                            </Col>
                                            <Col span={8}>
                                                <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.cleanRoomTaskId} style={{ width: 120 }} onChange={this.cleanRoomTaskIdOnChange}>
                                                    <Option value={0}>-- Select --</Option>
                                                    {configuration !== null ? (
                                                        stayMenuCategories.map(item => {
                                                            return (
                                                                <Option value={item.parentId}>{item.parentName}</Option>
                                                            )
                                                        })
                                                    ) : null}
                                                </Select>
                                            </Col>
                                        </Row>
                                }

                                {
                                    conciergeTitle === '' ?
                                        null
                                        :
                                        <Row className='generalSetting-row-subcategory'>
                                            <Col span={4}>
                                                <Text className='generalSetting-text-subcategory'>{conciergeTitle}</Text>
                                            </Col>
                                            <Col span={8}>
                                                <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.conciergeTaskId} style={{ width: 120 }} onChange={this.conciergeItemChanged}>
                                                    <Option value={0}>-- Select --</Option>
                                                    {configuration !== null ? (
                                                        stayMenuCategories.map(item => {
                                                            return (
                                                                <Option value={item.parentId}>{item.parentName}</Option>
                                                            )
                                                        })
                                                    ) : null}
                                                </Select>
                                            </Col>
                                        </Row>
                                }

                                {
                                    defectReportTitle === '' ?
                                        null
                                        :
                                        <Row className='generalSetting-row-subcategory'>
                                            <Col span={4}>
                                                <Text className='generalSetting-text-subcategory'>{defectReportTitle}</Text>
                                            </Col>
                                            <Col span={8}>
                                                <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.defectReportTaskId} style={{ width: 120 }} onChange={this.defectReportTaskIdOnChange}>
                                                    <Option value={0}>-- Select --</Option>
                                                    {configuration !== null ? (
                                                        stayMenuCategories.map(item => {
                                                            return (
                                                                <Option value={item.parentId}>{item.parentName}</Option>
                                                            )
                                                        })
                                                    ) : null}
                                                </Select>
                                            </Col>
                                        </Row>
                                }

                                {/* {
                                    dndTitle === '' ?
                                        null
                                        :
                                        <Row className='generalSetting-row-subcategory'>
                                            <Col span={4}>
                                                <Text className='generalSetting-text-subcategory'>{dndTitle}</Text>
                                            </Col>
                                            <Col span={8}>
                                                <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.dndTaskId} style={{ width: 120 }} onChange={this.dndTaskIdOnChange}>
                                                    <Option value={0}>-- Select --</Option>
                                                    {configuration !== null ? (
                                                        stayMenuCategories.map(item => {
                                                            return (
                                                                <Option value={item.parentId}>{item.parentName}</Option>
                                                            )
                                                        })
                                                    ) : null}
                                                </Select>
                                            </Col>
                                        </Row>
                                } */}

                                {
                                    fnbTitle === '' ?
                                        null
                                        :
                                        <Row className='generalSetting-row-subcategory'>
                                            <Col span={4}>
                                                <Text className='generalSetting-text-subcategory'>{fnbTitle}</Text>
                                            </Col>
                                            <Col span={8}>
                                                <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.fnbTaskId} style={{ width: 120 }} onChange={this.fnbTaskIdOnChange}>
                                                    <Option value={0}>-- Select --</Option>
                                                    {configuration !== null ? (
                                                        stayMenuCategories.map(item => {
                                                            return (
                                                                <Option value={item.parentId}>{item.parentName}</Option>
                                                            )
                                                        })
                                                    ) : null}
                                                </Select>
                                            </Col>
                                        </Row>
                                }

                                {/* {
                                    frontOfficeTitle === '' ?
                                        null
                                        :
                                        <Row className='generalSetting-row-subcategory'>
                                            <Col span={4}>
                                                <Text className='generalSetting-text-subcategory'>{frontOfficeTitle}</Text>
                                            </Col>
                                            <Col span={8}>
                                                <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.frontOfficeTaskId} style={{ width: 120 }} onChange={this.frontOfficeTaskIdOnChange}>
                                                    <Option value={0}>-- Select --</Option>
                                                    {configuration !== null ? (
                                                        stayMenuCategories.map(item => {
                                                            return (
                                                                <Option value={item.parentId}>{item.parentName}</Option>
                                                            )
                                                        })
                                                    ) : null}
                                                </Select>
                                            </Col>
                                        </Row>
                                } */}

                                {/* {
                                    lateCheckoutTitle === '' ?
                                        null
                                        :
                                        <Row className='generalSetting-row-subcategory'>
                                            <Col span={4}>
                                                <Text className='generalSetting-text-subcategory'>{lateCheckoutTitle}</Text>
                                            </Col>
                                            <Col span={8}>
                                                <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.lateCheckoutTaskId} style={{ width: 120 }} onChange={this.lateCheckoutTaskIdOnChange}>
                                                    <Option value={0}>-- Select --</Option>
                                                    {configuration !== null ? (
                                                        stayMenuCategories.map(item => {
                                                            return (
                                                                <Option value={item.parentId}>{item.parentName}</Option>
                                                            )
                                                        })
                                                    ) : null}
                                                </Select>
                                            </Col>
                                        </Row>
                                } */}

                                {/* {
                                    laundryTitle === '' ?
                                        null
                                        :
                                        <Row className='generalSetting-row-subcategory'>
                                            <Col span={4}>
                                                <Text className='generalSetting-text-subcategory'>{laundryTitle}</Text>
                                            </Col>
                                            <Col span={8}>
                                                <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.laundryTaskId} style={{ width: 120 }} onChange={this.laundryTaskIdOnChange}>
                                                    <Option value={0}>-- Select --</Option>
                                                    {configuration !== null ? (
                                                        stayMenuCategories.map(item => {
                                                            return (
                                                                <Option value={item.parentId}>{item.parentName}</Option>
                                                            )
                                                        })
                                                    ) : null}
                                                </Select>
                                            </Col>
                                        </Row>
                                } */}

                                {/* {
                                    printFileTitle === '' ?
                                        null
                                        :
                                        <Row className='generalSetting-row-subcategory'>
                                            <Col span={4}>
                                                <Text className='generalSetting-text-subcategory'>{printFileTitle}</Text>
                                            </Col>
                                            <Col span={8}>
                                                <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.printFileTaskId} style={{ width: 120 }} onChange={this.printFileTaskIdOnChange}>
                                                    <Option value={0}>-- Select --</Option>
                                                    {configuration !== null ? (
                                                        stayMenuCategories.map(item => {
                                                            return (
                                                                <Option value={item.parentId}>{item.parentName}</Option>
                                                            )
                                                        })
                                                    ) : null}
                                                </Select>
                                            </Col>
                                        </Row>
                                } */}

                                {
                                    shoppingTitle === '' ?
                                        null
                                        :
                                        <Row className='generalSetting-row-subcategory'>
                                            <Col span={4}>
                                                <Text className='generalSetting-text-subcategory'>{shoppingTitle}</Text>
                                            </Col>
                                            <Col span={8}>
                                                <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.shoppingTaskId} style={{ width: 120 }} onChange={this.shoppingTaskIdOnChange}>
                                                    <Option value={0}>-- Select --</Option>
                                                    {configuration !== null ? (
                                                        stayMenuCategories.map(item => {
                                                            return (
                                                                <Option value={item.parentId}>{item.parentName}</Option>
                                                            )
                                                        })
                                                    ) : null}
                                                </Select>
                                            </Col>
                                        </Row>
                                }

                                {
                                    wakeupCallTitle === '' ?
                                        null
                                        :
                                        <Row className='generalSetting-row-subcategory'>
                                            <Col span={4}>
                                                <Text className='generalSetting-text-subcategory'>{wakeupCallTitle}</Text>
                                            </Col>
                                            <Col span={8}>
                                                <Select className='generalSetting-select' value={configuration === null ? 0 : configuration.wakeUpCallTaskId} style={{ width: 120 }} onChange={this.wakeUpCallTaskIdOnChange}>
                                                    <Option value={0}>-- Select --</Option>
                                                    {configuration !== null ? (
                                                        stayMenuCategories.map(item => {
                                                            return (
                                                                <Option value={item.parentId}>{item.parentName}</Option>
                                                            )
                                                        })
                                                    ) : null}
                                                </Select>
                                            </Col>
                                        </Row>
                                }

                                <Row className='generalSetting-row-button'>
                                    <Col span={4}>
                                    </Col>
                                    <Col span={8}>
                                        <Button type='primary' className='generalSetting-button' onClick={this.saveGeneralSettingClicked}>Save</Button>
                                    </Col>
                                </Row>
                            </Spin>
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default GeneralSettingPage;